import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiPost } from 'services/api';
import { TResultUploadSales } from 'types/bulkUpload';
import { PAYMENT_TYPES } from 'types/orders';


const { REACT_APP_SUBSCRIPTION } = process.env;

export const downloadOrdersTemplate = async (
  organizationId: number,
  billingCountry: string,
  billingDocument: string,
  agreementDays?: number
): Promise<{ url: string }> => {
  return apiPost<AxiosRequestConfig, any, { data: { url: string } }>(
    `${REACT_APP_SUBSCRIPTION}/bulk-upload/order-template`,
    {
      organizationId,
      billingCountry,
      billingDocument,
      agreementDays,
      paymentMethod: PAYMENT_TYPES.TRANSFER_USD
    }
  )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error));
};

export const uploadOrdersTemplate = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  return apiPost<AxiosRequestConfig, any, { data: TResultUploadSales }>(
    `${REACT_APP_SUBSCRIPTION}/bulk-upload/sales`,
    formData
  )
    .then(response => Promise.resolve(response.data))
    .catch((error: AxiosError) => Promise.reject(error));
};
